import classNames from 'classnames';
import { FC, useMemo } from 'react';
import { dateFormatForUI, formatDate, isPastDate } from 'utils/date';
import { useTranslation } from 'utils/i18n';

interface Props {
  date: string;
  clashCount?: number;
  onClick?: () => void;
}

const Header: FC<Props> = ({ date, clashCount = 0, onClick }) => {
  const { t } = useTranslation('common');
  const hasClashes = clashCount > 0;
  const classes = classNames('calendar__date_header', {
    'calendar__date_header--clashes': !!hasClashes,
  });

  const isBeforeEndOfDay = useMemo(() => isPastDate(date), [date]);

  return (
    <div className={classes}>
      <span>{formatDate(date, dateFormatForUI)}</span>
      <span className="calendar__date_header--right">
        {hasClashes && (
          <div className="clashes">
            <i className="fas fa-exclamation-triangle space__icon" />
            {t('advanced_booking.clash', { count: clashCount })}
          </div>
        )}
        {isBeforeEndOfDay && <span>{t('advanced_booking.past_booking')}</span>}
        {!isBeforeEndOfDay && !!onClick && (
          <button className="button button--small" onClick={onClick}>
            {t('delete')}
          </button>
        )}
      </span>
    </div>
  );
};

export default Header;
